import request from '@/utils/request'

export function uploadFile(data, t) {
    let url = t ? '/upload?t=avatars' : '/upload'
    return request({
        url: url,
        method: 'post',
        data,
        contentType: 'multipart/form-data'
    })
}